
import styled from 'styled-components';
import { InputInterface } from './Radio';
import DesignTokens from 'uol-host-react-ui/dist/shared/DesignTokens.styles'

export const SC_Radio =styled.input<InputInterface>`
    accent-color:${(props) => DesignTokens.color[props.variant]};
    cursor: pointer;
`
